






















import {
  computed, defineComponent, ref,
} from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

import {
  thMonthsMini,
  backwardTenYear,
  NOW_START_MONTH,
  NOW_END_MONTH,
  NOW_YEAR,
  NOW_MONTH,
} from '@/utils';

const CommonWrapYearMonthSelector = defineComponent({
  props: {
    value: {
      default: () => ({
        from: NOW_START_MONTH,
        to: NOW_END_MONTH,
      }),
    },
    label: { type: String },
    placeholder: { type: String },
    allowedAllMonth: { type: Boolean },
    level: {},
  },
  setup(props, { emit }) {
    const computedMonths = computed(() => {
      if (props.allowedAllMonth) {
        return ['ทั้งหมด', ...thMonthsMini];
      }
      return thMonthsMini;
    });
    const computedClass = computed(() => {
      if (props.level === 'white') {
        return 'bg-white';
      }
      return 'bg-primary-100';
    });
    // const selectedYear = ref(NOW_YEAR + 543);
    // const selectedMonth = ref(NOW_MONTH);
    const computedValue = computed(() => {
      const cur = new Date(props.value.from);
      const end = new Date(props.value.to);
      let month = cur.getMonth();

      if (cur.getMonth() === 0 && end.getMonth() === 11) month = 0;
      else month = cur.getMonth() + 1;

      const year = cur.getFullYear() + 543;
      return {
        month,
        year,
      };
    });

    function getMonth(monthNum: string) {
      if (monthNum === '0') { // Which mean all month.
        return {
          from: '01',
          to: '12',
        };
      }
      const m = String(parseInt(monthNum, 10)).padStart(2, '0');
      return {
        from: m,
        to: m,
      };
    }

    function emitInput(event: any, type: string) {
      let y = 0;
      let m = { from: '', to: '' };
      if (type === 'YEAR') {
        y = parseInt(event.target.value, 10) - 543;
        m = getMonth(`${computedValue.value.month}`);
      } else {
        y = computedValue.value.year - 543;
        m = getMonth(event.target.value);
      }

      const from = `${y}-${m.from}-01`;
      const to = `${y}-${m.to}-01`;
      emit('input', {
        from,
        to: useFormat.date(to).computerShortDateEndOfMonth(),
      });
    }

    return {
      computedMonths,
      backwardTenYear,
      computedClass,

      computedValue,

      emitInput,
    };
  },
});

export default CommonWrapYearMonthSelector;
